export const isCanceledApiError = (error) => error?.code === 'ERR_CANCELED'
  || error?.__CANCEL__ === true;

export const getApiErrorMessage = (error, fallback = '请求失败，请稍后重试') => {
  if (isCanceledApiError(error)) return '';

  const message = error?.response?.data?.msg ?? error?.data?.msg;
  if (typeof message === 'string' && message.trim()) return message;

  if (error?.code === 'ERR_NETWORK') return '网络异常，请检查网络后重试';
  if (error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') return '请求超时，请稍后重试';

  return fallback;
};
export const getApiResponseErrorMessage = (response, fallback = '请求失败，请稍后重试') => (
  response?.data?.msg || fallback
);